import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';

import CommonButton from '../../../components/common-button/CommonButton';
import { ICONS } from '../../../icons';
import Icon from '../../../icons/Icon';

import scss from './ActionsSection.module.scss';

const ActionsSection = ({ dirty, valid, isLoading, onDiscard, onSubmit, disableDiscard, disableSubmit }) => {
  const { t } = useTranslation('projects');

  return (
    <div className={scss.actions}>
      <CommonButton
        styleColor='secondary'
        type='reset'
        maxWidth={100}
        disabled={!dirty || isLoading || disableDiscard}
        onClick={onDiscard}>
        <Icon icon={ICONS.Delete} />
        {t('discard')}
      </CommonButton>

      <CommonButton
        styleColor='primary'
        type='submit'
        onClick={onSubmit}
        maxWidth={100}
        disabled={!dirty || !valid || isLoading || disableSubmit}>
					{isLoading ? <ThreeDots height={15} width={40} /> : null}
        {t('save')}
      </CommonButton>
    </div>
  );
};

export default memo(ActionsSection);
